/* eslint-disable react/jsx-key */
import { Button } from '@mui/material';
import { useStoreState } from 'easy-peasy';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { initCourseAssessment } from '../../../../../helper/api.helper';
import Loader from '../../../../../components/loader/Loader';
import { getOrgCode } from '../../../../../helper/utils.helper';

const Assessment = ({ section, setVisitedPages, courseActivityId }) => {
  const [isLoading, setLoading] = useState(false);
  const user = useStoreState((state) => state.user);

  function startAssessment() {
    const orgCode = getOrgCode();
    setLoading(true);
    if (user) {
      initCourseAssessment(orgCode, courseActivityId, section.id)
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 'success') {
            setLoading(false);
            window.location.href = res.assessmentUrl;
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.message);
        });
    } else {
      setLoading(false);
      toast.error('Failed to initiate assessment');
    }
  }

  useEffect(() => {
    if (section?.assessment_completion_time) {
      setVisitedPages((prevState) => ({
        ...prevState,
        [section.id]: true
      }));
    }
  }, []);

  return (
    <div className="assessment-wrapper">
      {isLoading ? <Loader /> : null}
      <h4>{section?.name}</h4>
      <div className="margin-top--md">
        {section?.body?.map((section, i) =>
          section.type === 'points' ? (
            <ul key={i}>
              {section.text.map((text) => (
                <li className="margin-top--sm" key={text}>
                  {text}
                </li>
              ))}
            </ul>
          ) : (
            section.text.map((text) => (
              <p className="margin-top--sm" key={text}>
                {text}
              </p>
            ))
          )
        )}
      </div>
      {!section ? (
        <></>
      ) : section?.report_url ? (
        <Button
          href={section?.report_url}
          target="_blank"
          variant="contained"
          color="primary"
          sx={{ maxHeight: '30px', marginTop: '20px' }}>
          View report
        </Button>
      ) : section?.assessment_url && section?.assessment_submitted ? (
        <p className="margin-top--md gray-text">
          Generating report - refresh in a minute or check back soon.
        </p>
      ) : section?.assessment_url ? (
        <Button
          href={section?.assessment_url}
          variant="contained"
          color="primary"
          sx={{ maxHeight: '30px', marginTop: '20px' }}>
          Continue assessment
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          sx={{ maxHeight: '30px', marginTop: '20px' }}
          onClick={startAssessment}>
          Start assessment
        </Button>
      )}

      <style jsx>
        {`
          .assessment-wrapper {
            padding: 0px 40px 40px 40px;
          }
          @media only screen and (max-width: 600px) {
            .assessment-wrapper {
              padding: 0px 20px 20px 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Assessment;
